import { useEffect } from 'react';

import { trackDynamicComponentViewed } from '../analytics/dynamicComponentMixpanel';
import type { ComponentInstance, ComponentType } from '../types';
import {
  buildDynamicComponentViewKey,
  tryMarkMixpanelViewSent
} from '../utils/userScopedDynamicStorage';

/**
 * Fires a single `DYNAMIC_COMPONENT_VIEWED` Mixpanel event per
 * instance id per user+branch. Skips FE-only static banners.
 */
const useTrackDynamicView = (
  instance:
    | (ComponentInstance & { is_frontend_static_banner?: boolean })
    | undefined,
  componentType: ComponentType
): void => {
  const instanceId = instance?.id;
  const isStatic = instance?.is_frontend_static_banner;

  useEffect(() => {
    if (!instanceId || isStatic || !instance) return;
    const key = buildDynamicComponentViewKey(componentType, instanceId);
    if (tryMarkMixpanelViewSent(key)) {
      trackDynamicComponentViewed(instance, componentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instanceId, componentType]);
};

export default useTrackDynamicView;
